import React, { createContext, useContext, useState } from 'react';

type ModalType = 'linkedin-reauth';

interface ModalData {
  type: ModalType;
  isInitialSetup?: boolean;
  onReauthorize: () => void;
}

interface ModalContextValue {
  modalData: ModalData | null;
  openModal: (data: ModalData) => void;
  closeModal: () => void;
  isOpen: boolean;
}

const ModalContext = createContext<ModalContextValue | undefined>(undefined);

export const ModalProvider = ({ children }: { children: React.ReactNode }) => {
  const [modalData, setModalData] = useState<ModalData | null>(null);

  const openModal = (data: ModalData) => setModalData(data);
  const closeModal = () => setModalData(null);

  return (
    <ModalContext.Provider 
      value={{
        modalData,
        openModal,
        closeModal,
        isOpen: modalData?.type === 'linkedin-reauth'
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
}; 